import Vue from 'vue'
import { extend, ValidationObserver, ValidationProvider, localize } from 'vee-validate3'
import en from 'vee-validate3/dist/locale/en.json'
import * as rules from 'vee-validate3/dist/rules'

// setInteractionMode('eager')

Object.keys(rules).map(rule => {
  extend(rule, rules[rule])
})

extend('double', value => {
  return !isNaN(value)
})

localize('en', en)

// extend('required', required)
// extend('email', email)
// extend('min', min)
// extend('max', max)
// extend('numeric', numeric)
// extend('max_value', maxValue)

// Register it globally
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
